module.exports = __webpack_public_path__ + "media/sword_slash.884c7e13.mp3";